import * as React from "react";
import "./core_field.css";
import { CoreText, CoreTextType } from "../text/text";

export enum CoreInputType {
  small = "small",
  default = "default",
  big = "big",
}
export const CoreInput = (props: {
  label: string;
  native?: boolean;
  inputType?: React.HTMLInputTypeAttribute;
  autoComplete?: string;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  invalid?: boolean;
  maxLength?: number;
  placeholder?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  textareaRef?: React.Ref<HTMLTextAreaElement>;
  value?: string;
  subLabel?: React.ReactNode;
  onChange?: (value: string) => void;
  validation?: (value: string) => boolean;
  error?: string;
  type?: CoreInputType;
  trim?: boolean;
  styleContentEditable?: React.CSSProperties;
  style?: React.CSSProperties;
  isFormBuilder?: boolean;
}) => {
  const [value, setValue] = React.useState<string>(() => props.value ?? "");
  const ref = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (ref.current) ref.current.innerText = props.value ?? "";
    setValue(props.value ?? "");
  }, [props.value]);

  const isSmall =
    props.type !== undefined && props.type.isEqual(CoreInputType.small);
  const id = React.useId();
  if (props.native) {
    const fieldProps = {
      id, placeholder: props.placeholder, value: props.value ?? "", disabled: props.disabled, maxLength: props.maxLength,
      "aria-invalid": props.invalid, inputMode: props.inputMode, onKeyDown: props.onKeyDown,
      onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => props.onChange?.(props.trim ? event.target.value.trim() : event.target.value),
    };
    return <div className="core-field" style={props.style}>
      <label htmlFor={id}><CoreText as="span" type={CoreTextType.small} text={props.label} /></label>
      {props.multiline ? <textarea {...fieldProps} ref={props.textareaRef} rows={props.rows ?? 4} /> : <input {...fieldProps} type={props.inputType} autoComplete={props.autoComplete} />}
      {props.subLabel}
    </div>;
  }
  return (
    <div
      style={Object.assign(
        {
          backgroundColor: "var(--ui-surface)",
          height: isSmall ? 40 : 58,
          borderRadius: "var(--ui-radius)",
          border: "2px solid var(--ui-outline)",
          padding: "10px 10px 10px 10px",
        },
        props.style
      )}
    >
      <CoreText
        type={CoreTextType.small}
        style={isSmall ? { fontSize: 8, position: "relative", top: -8 } : {}}
        text={props.label}
      />

      <div
        ref={ref}
        contentEditable={true}
        role="textbox"
        aria-label={props.label}
        style={Object.assign(
          {
            backgroundColor: "#00008000",
            border: 1,
            fontSize: isSmall ? 12 : 16,
            fontFamily: "var(--ui-font)",
            color: "var(--ui-text)",
            height: 24,
            width: "100%",
            userSelect: "none",
            outline: "none",
            position: isSmall ? "relative" : undefined,
            top: isSmall ? -8 : undefined,
          },
          props.styleContentEditable
        )}
        onInput={(e) => {
          let val = e.currentTarget.innerText;

          setValue(val);
          if (props.trim) val = val.trim().replaceAll("\n", "");
          if (props.onChange && (!props.validation || props.validation(val))) {
            props.onChange(val);
          }
        }}
      />
      {value ? (
        props.validation ? (
          props.validation(value) ? null : (
            <div style={{ color: "#ff1d0c" }}>
              {props.error ? props.error : "error"}
            </div>
          )
        ) : null
      ) : null}
    </div>
  );
};
